import { render, staticRenderFns } from "./AuthorsTitle.vue?vue&type=template&id=31a6bdb8"
import script from "./AuthorsTitle.vue?vue&type=script&lang=js"
export * from "./AuthorsTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports